import React, { useState } from 'react';
import { Card, Typography, CardActionArea, CardActions, CardHeader, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
    card: {
        color: 'transparent',
    },
    over: {
        color: 'transparent',
        boxShadow: ' 0 7px 20px rgba(0,0,0,0.15), 0 8px 10px rgba(0,0,0,0.2), 0 6px 3px -4px rgba(0,0,0,0.15)'
    }
}));


interface IMenuCard {
    title?: string
    bottomText: string
}

let MenuCard = (props: IMenuCard) => {
    let { classes } = useStyles();

    let [className, setClassName] = useState(classes.card);

    return (
        <Card className={className}
            style={{ height: '325px' }}
            onMouseOver={(e: any) => setClassName(classes.over)}
            onMouseOut={(e: any) => setClassName(classes.card)}
        >
            <CardHeader title={props.title} />
            <CardActionArea>
                ACTIONS
            </CardActionArea>
            <CardActions style={{ textAlign: 'center', }}>
                <Grid container spacing={1}>
                    <Grid item xs sm md lg>
                        <Typography variant="body1" color="textSecondary" style={{ fontSize: 18, fontWeight: 600 }}>
                            {props.bottomText}
                        </Typography>
                    </Grid>
                </Grid>
            </CardActions>
        </Card >
    );
}

export default MenuCard;